import { Injectable } from '@angular/core';
import { BasePagedCrudService } from '../shared/crud/base-crud.service';
import { IdentityRoleCreateDto, IdentityRoleDto, IdentityRoleUpdateDto } from './models/RoleDtos';
import { HttpClient } from '@angular/common/http';
import { CrudSettings, QueryParams } from '../shared/crud/abstractions/base-crud';
import { EnvironmentService } from '../core/environment/environment.service';
import {DialogService} from "../shared/dialog/dialog.service";
import {MatSnackBar} from "@angular/material/snack-bar";

export class RoleCrudSettings implements CrudSettings<string, IdentityRoleDto> {
  baseUrl = '';
  postUrl = undefined;
  queryParam = undefined;
  createSuffix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'PATH';
  editSuffix = undefined;
  editIdLocation: 'PATH' | 'QUERY' = 'PATH';
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  getListSuffix = undefined;
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'PATH';
  idGetter = (entity: IdentityRoleDto) => entity.id;

  mapper(id: string): QueryParams {
    const dict = new Map<string, string>();
    dict.set('id', id);
    return { params: dict }
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.baseUrl + '/api/identity/roles';
  }
}

@Injectable({
  providedIn: null
})
export class RoleDataService
  extends BasePagedCrudService<string, IdentityRoleDto, IdentityRoleCreateDto, IdentityRoleUpdateDto>{

  constructor(private _http: HttpClient, private environmentService: EnvironmentService, override dialogService: DialogService) {
    super(_http, new RoleCrudSettings(environmentService), dialogService);
  }
}
